module.exports = __webpack_public_path__ + "static/media/cloud-suite-img-min.ef976021.jpg";